import { Box, BoxProps, SxProps, useTheme } from '@mui/material';

import { mergeSxProps } from '~/utils/helpers/sxProps';

type PropsType = BoxProps;

export const SolaForceSubheading = (props: PropsType) => {
  const { children, sx, ...boxProps } = props;

  const theme = useTheme();

  const defaultSx: SxProps = {
    fontFamily: theme.typography.fontFamily ?? 'sans-serif',
    fontSize: '1rem',
    fontWeight: '700',
    margin: theme.spacing(0.5, 0, 1.5, 0),
  };

  return (
    <Box {...boxProps} sx={mergeSxProps(defaultSx, sx)}>
      {children}
    </Box>
  );
};
